/**
 * VerifiedBadge - Shows device verification status
 */

import PropTypes from 'prop-types';
import { useI18n } from '../../context/I18nContext';
import './VerifiedBadge.css';

const VerifiedBadge = ({ isVerified, isCrossSigned, isVerifying, size = 'medium' }) => {
  const { t } = useI18n();

  if (isVerifying) {
    return (
      <span className={`verified-badge verified-badge--verifying verified-badge--${size}`}>
        <span className="verified-badge__icon">
          <ion-icon name="time-outline" />
        </span>
        <span className="verified-badge__text">{t('VerifiedBadge.verifying', {}, 'Verifying')}</span>
      </span>
    );
  }

  if (isVerified) {
    return (
      <span className={`verified-badge verified-badge--verified verified-badge--${size}`}>
        <span className="verified-badge__icon">
          <ion-icon name="checkmark" />
        </span>
        <span className="verified-badge__text">{t('VerifiedBadge.verified', {}, 'Verified')}</span>
      </span>
    );
  }

  return (
    <span className={`verified-badge verified-badge--unverified verified-badge--${size}`}>
      <span className="verified-badge__icon">
        <ion-icon name="warning" />
      </span>
      <span className="verified-badge__text">{t('VerifiedBadge.notVerified', {}, 'Not Verified')}</span>
    </span>
  );
};

VerifiedBadge.propTypes = {
  isVerified: PropTypes.bool,
  isCrossSigned: PropTypes.bool,
  isVerifying: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default VerifiedBadge;